import styled, { keyframes } from 'styled-components'

import { ReactNode } from 'react'

interface FadeInProps {
  children: ReactNode
}

const fadeAnimation = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const FadeWrapper = styled.div`
  @media (prefers-reduced-motion: no-preference) {
    animation: ${fadeAnimation} 200ms ease-in;
  }
`

export const FadeIn = ({ children }: FadeInProps) => <FadeWrapper>{children}</FadeWrapper>
